// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* core-button
*/
:host {
  display: flex;
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
  font-size: var(--core-font-sizes-content);
  border-radius: var(--core-border-radius);
  height: 44px;
  position: relative;
  overflow: hidden;
}
:host i {
  font-size: 20px;
  margin-right: 20px;
}
:host .core-button-inner {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
:host.inline {
  height: min-content;
  width: max-content;
}
:host.clear:hover, :host.inline:hover {
  filter: brightness(85%);
}
:host.outline:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}
:host.solid:hover {
  filter: brightness(1.2);
}
:host.disabled {
  cursor: default;
  opacity: 0.4;
  pointer-events: none;
}
:host[padded] .core-button-inner {
  padding: 0 var(--core-padding-thin);
}
:host[core-list-item] {
  border-radius: 0;
}
:host[core-list-item] .core-button-inner {
  display: flex;
}
:host:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.25);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}
:host:active::after {
  animation: ripple 0.5s ease-out;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 1;
  }
  20% {
    transform: scale(25, 25);
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(35, 35);
  }
}`, "",{"version":3,"sources":["webpack://./src/core-modules/components/core-button/core-button.component.scss"],"names":[],"mappings":"AAAA;;CAAA;AAGA;EACI,aAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACI,eAAA;EACA,kBAAA;AACR;AAEI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAR;AAGI;EACI,mBAAA;EACA,kBAAA;AADR;AAII;EAEI,uBAAA;AAHR;AAMI;EACI,sDAAA;AAJR;AAOI;EACI,uBAAA;AALR;AAQI;EACI,eAAA;EACA,YAAA;EACA,oBAAA;AANR;AAUQ;EACI,mCAAA;AARZ;AAYI;EACI,gBAAA;AAVR;AAYQ;EACI,aAAA;AAVZ;AAcI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,qCAAA;EACA,UAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;AAZR;AAeI;EACI,+BAAA;AAbR;;AAiBA;EACI;IACI,sBAAA;IACA,UAAA;EAdN;EAiBE;IACI,wBAAA;IACA,UAAA;EAfN;EAkBE;IACI,UAAA;IACA,wBAAA;EAhBN;AACF","sourcesContent":["/**\r\n* core-button\r\n*/\r\n:host {\r\n    display: flex;\r\n    cursor: pointer;\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    font-size: var(--core-font-sizes-content);\r\n    border-radius: var(--core-border-radius);\r\n    height: 44px;\r\n    position: relative;\r\n    overflow: hidden;\r\n\r\n    i {\r\n        font-size: 20px;\r\n        margin-right: 20px;\r\n    }\r\n\r\n    .core-button-inner {\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    &.inline {\r\n        height: min-content;\r\n        width: max-content;\r\n    }\r\n\r\n    &.clear:hover,\r\n    &.inline:hover {\r\n        filter: brightness(85%);\r\n    }\r\n\r\n    &.outline:hover {\r\n        background-color: rgba(255, 255, 255, 5%) !important;\r\n    }\r\n\r\n    &.solid:hover {\r\n        filter: brightness(1.2);\r\n    }\r\n\r\n    &.disabled {\r\n        cursor: default;\r\n        opacity: 0.4;\r\n        pointer-events: none;\r\n    }\r\n\r\n    &[padded] {\r\n        .core-button-inner {\r\n            padding: 0 var(--core-padding-thin);\r\n        }\r\n    }\r\n\r\n    &[core-list-item] {\r\n        border-radius: 0;\r\n\r\n        .core-button-inner {\r\n            display: flex;\r\n        }\r\n    }\r\n\r\n    &:after {\r\n        content: '';\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        width: 5px;\r\n        height: 5px;\r\n        background: rgba(255, 255, 255, .25);\r\n        opacity: 0;\r\n        border-radius: 100%;\r\n        transform: scale(1, 1) translate(-50%);\r\n        transform-origin: 50% 50%;\r\n    }\r\n\r\n    &:active::after {\r\n        animation: ripple 0.5s ease-out;\r\n    }\r\n}\r\n\r\n@keyframes ripple {\r\n    0% {\r\n        transform: scale(0, 0);\r\n        opacity: 1;\r\n    }\r\n\r\n    20% {\r\n        transform: scale(25, 25);\r\n        opacity: 1;\r\n    }\r\n\r\n    100% {\r\n        opacity: 0;\r\n        transform: scale(35, 35);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
